module.exports = __webpack_public_path__ + "img/744.7f2bcbe6.jpg";